module.exports = __webpack_public_path__ + "img/Hatchbacks_disabled.fe414f70.svg";